import { Button, Col, Modal, Form, Row, Table, Input, Popconfirm } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Attachment, Detail } from '../common';
import { CommonFileUpload } from '../common/CommonFileUpload';
import { useFields } from '../fields';
import { displayUtil } from '../util';
import { DocCommentDto, DocDetailCommentDto } from './api';
import './index.css';
import { CommonFileDisplay } from '../common/CommonFileDisplay';

const { TextArea } = Input;

export interface Props {
  urlId?: string;
  formDto?: DocDetailCommentDto;
  detailCommentOptions?: DocCommentDto[];
  visible: boolean;
  disabled: boolean;
  handleCommentCreate: (data: DocCommentDto) => void;
  close: () => void;
}

export function DocDetailComment(props: Props) {

  const [attachments, setAttachments] = useState<Attachment[]>([]);
  const [form] = Form.useForm<DocDetailCommentDto>();
  const [formComment] = Form.useForm<DocCommentDto>();
  const acceptFlag = useFields('acceptFlag');
  const readFlag = useFields('readFlag');
  const replyFlag = useFields('replyFlag');

  useEffect(() => {
    if (!!props.formDto) {
      form.setFieldsValue(props.formDto);
    }
  },[form, props.formDto]);

  const replyTimeTitle = <FormattedMessage id='docInfo.replyTime' />;
  const replyMessageTitle = <FormattedMessage id='docInfo.replyContent' />;
  const detailCommentTitle = <FormattedMessage id='docInfo.detailComment' />;
  const sendContentTitle = <FormattedMessage id='docInfo.sendInfo' />;
  const usernameTitle = <FormattedMessage id='docInfo.replyUserName' />;
  const commentNo = <FormattedMessage id='docInfo.commentNo' />;
  const commentTitle = <FormattedMessage id='docInfo.comment' />;

  const confirm = <FormattedMessage id='common.confirm' />;
  const replyCancel = <FormattedMessage id='common.cancel' />;
  const replyConfirm = <FormattedMessage id='message.replyConfirm' />;
  const reply = <FormattedMessage id='docInfo.reply' />;
  const replyContentTitle = <FormattedMessage id='docInfo.replyContent' />;
  const uploadTitle = <FormattedMessage id='common.upload' />;

const fileDownloadProps = {
  attachments: !!props.formDto?.attachments ? props.formDto.attachments : [],
  canUpload: false,
  persist: () => { },
  remove: () => { },
};

  const col1: [JSX.Element, any][] = [
    [<FormattedMessage id='docInfo.acceptFlag' />, displayUtil.field(acceptFlag)(props.formDto?.acceptFlag)],
    [<FormattedMessage id='docInfo.readFlag' />, displayUtil.field(readFlag)(props.formDto?.readFlag)],
    [<FormattedMessage id='docInfo.replyFlag' />, displayUtil.field(replyFlag)(props.formDto?.replyFlag)],
    [<FormattedMessage id='docInfo.supplier' />, props.formDto?.supplier],
    [<FormattedMessage id='docInfo.userName' />, props.formDto?.userName],
    [<FormattedMessage id='docInfo.sendTime' />, props.formDto?.sendTime],
    [<FormattedMessage id='docInfo.docFiles' />, <CommonFileDisplay  {...fileDownloadProps} />],
    [<></>, ''],
    [<></>, ''],
  ]

  const width250 = '250px';
  const width50 = '50px';
  const width25 = '25px';

  const column: ColumnsType<DocCommentDto> = [
    {
      title: commentNo,
      dataIndex: 'commentNo',
      width: width25,
    },
    {
      title: usernameTitle,
      dataIndex: 'userName',
      width: width50,
    },
    {
      title: replyMessageTitle,
      dataIndex: "comment",
      width: width250,
    },
    {
      title: replyTimeTitle,
      dataIndex: "createdDate",
      width: width50,
    },
  ]

  const handleSubmit = (commentDto: DocCommentDto) => {
    commentDto.documentId = form.getFieldValue("documentId");
    commentDto.supplier = form.getFieldValue("supplier");
    commentDto.attachments = [];
    commentDto.attachments = attachments;
    props.handleCommentCreate(commentDto);
    formComment.resetFields();
    setAttachments([]);
  };

  return (

    <Modal
      title={detailCommentTitle}
      width={'100%'}
      footer={null}
      visible={props.visible}
      destroyOnClose={true}
      onCancel={props.close}
      >
      <Form
        className="form"
        form={form}
        preserve={false}
        layout={'horizontal'}
        colon={false}
        requiredMark={true}
        size={'large'}
        style={{height: '100%'}}
      >
        <p style={{ fontSize: 16, fontWeight: 500, marginBottom: 0, borderBottom: '1px solid #f0f0f0' }}>{sendContentTitle}</p>
        <Detail cols={col1} />

        <p style={{ fontSize: 16, fontWeight: 500, marginBottom: 0, marginTop: 20, borderBottom: '1px solid #f0f0f0', transform: 'translateY(-60px)' }}>
          {replyContentTitle}</p>
        <Row style={{ marginTop: -10, transform: 'translateY(-60px)', height: '500px' }}>
          <Col span="24">
            <Table<DocCommentDto>
              className="list-detail-table"
              rowClassName={displayUtil.rowClassName} // テーブルは 1 行おきに色が変わります
              sticky={false}
              pagination={false}
              scroll={{ y: '38vh' }}
              columns={column}
              dataSource={props.detailCommentOptions}
              rowKey={'id'}
            />
          </Col>
        </Row>
      </Form>
      <Form
        className="form"
        form={formComment}
        preserve={false}
        onFinish={handleSubmit}
        layout={'horizontal'}
        colon={false}
        requiredMark={true}
        size={'large'}
        style={{height: '100%'}}
      >
      <Form.Item name='comment' label={commentTitle} style={{ fontWeight: 'bold' }}>
        <TextArea showCount autoSize={{ minRows: 5 }} maxLength={200} disabled={false}/>
      </Form.Item>
      <Col span={5} style={{ fontWeight: 'bold' }}>
          {uploadTitle}
      
      <Form.Item name='attachments' noStyle>
        <CommonFileUpload
          attachments={[]}
          canUpload={true}
          persist={(uuid: string) => {
            setAttachments([...attachments, { id: -1, uuid: uuid }]);
          }}
          remove={(uuid: string) => {
            setAttachments(attachments.filter((attachment: Attachment) => attachment.uuid !== uuid))
          }}
        />
      </Form.Item>
      </Col>
      <Col className='replyBtn'>
        <Popconfirm
          title={replyConfirm}
          onConfirm={() => {
            formComment.submit()
          }}
          okText={confirm}
          cancelText={replyCancel}
          disabled={false}
          >
          <Button>{reply}</Button>
        </Popconfirm>
      </Col>
      </Form>
    </Modal >
  );
}
